module.exports = __webpack_public_path__ + "static/media/link5.00f50e51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/link5.svg
// module id = 3126
// module chunks = 7